/*
  Phase 2b — Variant-aware gallery hero swap.

  Subscribes to trautis:variant-change. When the new variant has a featured_media,
  swaps the hero image (cross-fade) and scrolls the matching thumb into view.
  Also closes the lightbox if open (simpler than mid-flight image swap).
*/

(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  } else {
    root.TrautisGalleryVariantSwap = api;
    if (root.document && root.document.addEventListener) {
      if (root.document.readyState === 'loading') {
        root.document.addEventListener('DOMContentLoaded', api.init);
      } else {
        api.init();
      }
    }
  }
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  function resolveTargetMediaId(variant) {
    if (!variant) return null;
    if (!variant.featured_media) return null;
    if (variant.featured_media.id == null) return null;
    return variant.featured_media.id;
  }

  function prefersReducedMotion() {
    return false; // motion forced on per owner request (was prefers-reduced-motion check)
  }

  function isMobileCarousel() {
    return typeof window !== 'undefined'
        && window.matchMedia
        && window.matchMedia('(max-width: 989px)').matches;
  }

  function closeLightbox() {
    // 2a's product-media-lightbox builds a modal with class .t-lightbox__close.
    var closeBtn = document.querySelector('.t-lightbox__close');
    if (closeBtn && typeof closeBtn.click === 'function') closeBtn.click();
  }

  function highlightThumb(sectionRoot, mediaId) {
    // 2a uses .t-media__thumb.is-active for the active thumb.
    var thumbs = sectionRoot.querySelectorAll('.t-media__thumb');
    var target = null;
    thumbs.forEach(function (t) {
      var match = String(t.getAttribute('data-media-id')) === String(mediaId);
      t.classList.toggle('is-active', match);
      if (match) target = t;
    });
    if (target && typeof target.scrollIntoView === 'function') {
      target.scrollIntoView({
        behavior: prefersReducedMotion() ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'nearest'
      });
    }
  }

  function swapHero(sectionRoot, mediaId) {
    // 2a uses .t-media__slide.is-active { display: block; } for visibility.
    var slides = sectionRoot.querySelectorAll('.t-media__slide');
    var target = null;
    slides.forEach(function (s) {
      if (String(s.getAttribute('data-media-id')) === String(mediaId)) target = s;
    });
    if (!target) return false;

    // Mobile carousel: scroll-snap controls visibility; class is just tracking.
    if (isMobileCarousel()) {
      slides.forEach(function (s) { s.classList.toggle('is-active', s === target); });
      var hero = sectionRoot.querySelector('.t-media__hero');
      if (hero && typeof target.scrollIntoView === 'function') {
        target.scrollIntoView({
          behavior: prefersReducedMotion() ? 'auto' : 'smooth',
          inline: 'start',
          block: 'nearest'
        });
      }
      return true;
    }

    // Cross-fade: prepare current active as fade-out, new as fade-in.
    if (prefersReducedMotion()) {
      slides.forEach(function (s) { s.classList.toggle('is-active', s === target); });
    } else {
      var prevActive = sectionRoot.querySelector('.t-media__slide.is-active');
      target.style.opacity = '0';
      target.classList.add('is-active');
      if (prevActive && prevActive !== target) {
        prevActive.style.transition = 'opacity 180ms ease';
        prevActive.style.opacity = '0';
        setTimeout(function () {
          prevActive.classList.remove('is-active');
          prevActive.style.opacity = '';
          prevActive.style.transition = '';
        }, 200);
      }
      requestAnimationFrame(function () {
        target.style.transition = 'opacity 180ms ease';
        target.style.opacity = '1';
        setTimeout(function () {
          target.style.transition = '';
          target.style.opacity = '';
        }, 220);
      });
    }

    return true;
  }

  function initSection(sectionRoot) {
    sectionRoot.addEventListener('trautis:variant-change', function (e) {
      closeLightbox();
      var variant = e.detail && e.detail.variant;
      var id = resolveTargetMediaId(variant);
      if (id == null) return;
      var swapped = swapHero(sectionRoot, id);
      if (swapped) highlightThumb(sectionRoot, id);
    });
  }

  function init() {
    document.querySelectorAll('[data-product-section]').forEach(initSection);
  }

  return {
    init: init,
    resolveTargetMediaId: resolveTargetMediaId,
    isMobileCarousel: isMobileCarousel
  };
});
